<template>
  <b-modal
    id="switch-subscription-plan"
    ref="switch-subscription-plan"
    size="invite-member"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head seats">
      <h2 class="modal-title">
        {{ label.get("subscription_change_subscription_plan") }}
      </h2>
    </div>
    <div class="content-wrapper">
      <p
        class="seats-desc"
        v-html="
          label.get('subscription_change_subscription_plan_description', {
            changePlan: label.get(changePlan),
            nextPayment: nextPayment,
          })
        "
      />
      <div class="additional-seats-form switch">
        <div class="form-head">
          <span class="no">{{
            label.get("subscription_number_of_users")
          }}</span>
          <span class="price">{{
            label.get("subscription_price_per_user")
          }}</span>
          <span class="total">{{
            label.get("subscription_total_amount")
          }}</span>
        </div>
        <div class="form-fields">
          <span class="no">{{ activeUsers }} {{ label.get("users") }}</span>
          <span class="price">${{ changePlanPrice }}</span>
          <span class="total">${{ totalAmount }}</span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button type="reset" class="atto-btn cancel" @click="close">
          {{ label.get("cancel") }}
        </button>
        <button type="submit" class="atto-btn submit" @click="switchPlan">
          {{ label.get("confirm") }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import BillingService from "../services/BillingService";

export default {
  name: "SwitchSubscriptionPlanComponent",
  props: {
    changePlan: {
      type: String,
      default: "monthly_9",
    },
    nextPayment: {
      type: String,
      default: "",
    },
    activeUsers: {
      type: Number,
      default: 1,
    },
    changePlanPrice: {
      type: Number,
      default: 7,
    },
    totalAmount: {
      type: Number,
      default: 7,
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["switch-subscription-plan"].show();
  },
  methods: {
    close() {
      this.$root.$emit("hideSwitchSubscriptionPlan");
    },
    switchPlan() {
      this.$store.commit("showLoading");
      BillingService.switchSubscriptionPlan()
        .then((result) => {
          this.$store.commit("hideLoading");
          this.$root.$emit(
            "hideSwitchSubscriptionPlan",
            result.data.changePlan
          );
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>

<style lang="scss">
/* @media queries */
@mixin tablet {
  @media (max-width: 767px) and (min-width: 481px) {
    @content;
  }
}
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
/* End of: @media queries */
.modal-head {
  padding: 46px 48px 8px;
  position: relative;

  h2.modal-title {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.75rem;
    color: #262626;
  }

  a.manage-team-anchor {
    position: absolute;
    right: 48px;
    top: 48px;
    width: 160px;
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-family: $roboto-font;
    color: $atto-font-color;
    font-weight: 500;
    @include base-transition(ease color 0.15s);

    i {
      font-size: 0.75rem;
      color: $atto-font-color;
      width: 24px;
      height: 24px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-left: 43px;
      @include base-transition(ease color 0.15s);
    }

    &:hover {
      color: $atto-green;

      i {
        color: $atto-green;
      }
    }
  }

  &.seats {
    padding-bottom: 0;
  }
}

#switch-subscription-plan {
  .modal-footer {
    padding: 0 40px 48px;
  }
  .modal-content {
    .modal-body {
      .content-wrapper {
        padding: 40px 40px 24px 40px !important;
        @include tablet {
          padding: 20px !important;
        }
        @include mobile {
          padding: 20px !important;
        }
      }
    }
  }
}

.modal-invite-member {
  .modal-content {
    width: 100%;
    margin: 0 auto;
    .modal-body {
      padding: 0;

      .content-wrapper {
        padding: 40px 40px 0 40px !important;
        display: flex;
        flex-direction: column;

        p.seats-desc {
          font-size: 0.875rem;
          line-height: 1.25rem;
          color: $atto-font-color;
          font-family: $roboto-font;
          font-weight: 400;
          /*margin-bottom: 0 !important;*/

          strong {
            font-weight: bold;
          }

          b {
            text-transform: capitalize;
          }
        }

        .additional-seats-form {
          margin-top: 0px;
          padding-top: 16px;
          padding-right: 48px;
          position: relative;

          &.switch {
            padding-right: 0;
          }

          &:before {
            content: none;
          }

          .form-head {
            display: flex;
            width: 100%;
            @include mobile {
              /* padding: 2px; */
            }
            flex-direction: row;
            border: 1px solid #efefef;
            background-color: #fafafa;
            justify-content: space-between;

            span {
              font-weight: $roboto-medium;
              font-size: 10px;
              line-height: 11px;
              letter-spacing: 0.5px;
              color: $atto-not-active;
              width: auto;
              text-transform: uppercase;
              &:nth-child(2) {
                padding: 0 1rem;
              }
              &:last-child {
                text-align: right;
              }
            }
          }

          .form-fields {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 17px 12px;
            border-bottom: 2px solid #efefef;
            span {
              display: inline-flex;
              border: 0;
              font-size: 1rem;
              line-height: 1.5rem;
              color: #262626;
              font-family: "Roboto", sans-serif;
              justify-content: flex-end;
              width: 14%;
              &:first-child,
              &:nth-child(2) {
                justify-content: flex-start;
              }
            }

            input {
              display: inline-flex;
              border: 2px solid #efefef;
              padding: 6px 12px;
              width: 58px;
              font-size: 1rem;
              line-height: 1.5rem;
              color: #262626;
              font-family: "Roboto", sans-serif;
              text-align: left !important;

              /* Disabling Spinners */
              -webkit-appearance: none;
              -moz-appearance: textfield;
              margin-right: 36px;

              &::-webkit-inner-spin-button,
              &::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
            }
          }
        }

        &.seats {
          padding-top: 8px;
          padding-bottom: 0;

          .head-labels {
            .label {
              &.email {
                width: 288px !important;
              }
            }
          }

          .ps {
            max-height: calc(100vh - 550px);
          }
        }
      }
    }
  }

  .modal-footer {
    padding: 0 40px 40px;
    display: flex;
    align-items: inherit;
    flex-direction: column;

    .alert-message {
      position: absolute;
      right: 48px;
      bottom: 12px;
      font-size: 0.875rem;
      line-height: 1.5rem;
      color: $atto-red;
      font-family: $roboto-font;
      font-weight: 400;
      margin: 0;
    }

    .form-disclaimer {
      display: flex;
      flex-direction: column;
      margin: 0;

      &.top {
        margin: 4px 0 24px;
        margin-left: auto;

        p {
          font-size: 0.75rem;
          line-height: 1rem;
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          color: $atto-not-active;
          margin-bottom: 0;
        }
      }

      &.bottom {
        margin-top: 16px;
        width: 326px;
        margin-left: auto;

        p {
          font-size: 0.625rem;
          line-height: 0.875rem;
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          color: $atto-not-active;
          text-align: right;
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .form-buttons {
      display: flex;
      flex-direction: row;
      margin: 0;

      .atto-btn {
        flex-grow: 1;
      }
    }

    button.submit {
      margin-right: 0;
    }
  }
}
@media (max-width: 768px) {
  .modal-invite-member {
    max-width: calc(100% - 20px);
    margin: 0 auto;
    .modal-content {
      width: 95%;
      .modal-body {
        .content-wrapper {
          .additional-seats-form,
          .ps {
            padding-right: 0;
          }

          p.seats-desc {
            margin-bottom: 4px;
          }
        }

        .modal-footer {
          .form-buttons {
            flex-direction: column;

            button {
              width: 100%;
              margin-right: 0;
              margin-bottom: 8px;

              &.submit {
                order: -1;
              }

              &.cancel {
                margin-bottom: 0;
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
